var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File icons 24px/PNG",
    clipPath: "url(#clip0_62488_125525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V15H17C15.8954 15 15 15.8954 15 17V21H5C3.89543 21 3 20.1046 3 19V5ZM21 17C21 19.2091 19.2091 21 17 21V17H21ZM8.491 7.948C8.491 6.814 7.623 6.1 6.258 6.1H3.899V11H5.551V9.796H6.258C7.623 9.796 8.491 9.082 8.491 7.948ZM6.825 7.948C6.825 8.305 6.608 8.522 6.153 8.522H5.551V7.374H6.153C6.608 7.374 6.825 7.591 6.825 7.948ZM13.8628 6.1H12.2528V8.326L10.3908 6.1H9.03279V11H10.6428V8.774L12.5048 11H13.8628V6.1ZM17.8998 8.417V9.656C17.6968 9.74 17.5008 9.775 17.2978 9.775C16.5908 9.775 16.1288 9.285 16.1288 8.55C16.1288 7.794 16.5908 7.325 17.3188 7.325C17.7528 7.325 18.1098 7.507 18.4178 7.864L19.4748 6.933C18.9778 6.324 18.2008 5.988 17.2348 5.988C15.6178 5.988 14.4628 7.045 14.4628 8.55C14.4628 10.055 15.6178 11.112 17.1998 11.112C17.9208 11.112 18.7398 10.895 19.3348 10.489V8.417H17.8998Z",
    fill: "#0020C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62488_125525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.9631b37086d863696b0f1258de606215.svg";
export { ForwardRef as ReactComponent };